import { render, staticRenderFns } from "./salesGoodsDialog.vue?vue&type=template&id=b61c4c26&scoped=true"
import script from "./salesGoodsDialog.vue?vue&type=script&lang=js"
export * from "./salesGoodsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b61c4c26",
  null
  
)

export default component.exports